import { CT } from "../../../../consts";

export const PAGE_SIZE = 25;

// Matches CalendarTypeName.js's display strings (kept in sync manually —
// that component still renders the icon+label pair used elsewhere; this
// page drops the glyph per design_handoff_calendars_index README §4
// ("No template glyphs... a second visual language") but needs the same
// label text for the Template column and the Template filter's options.
export const TEMPLATE_LABELS = {
  [CT.monthly]: "Full Calendar",
  [CT.eventList]: "Events List",
  [CT.weekly]: "Weekly view",
  [CT.card]: "Cards (Grid)",
  [CT.cardList]: "Cards (List)",
  [CT.cardSlider]: "Cards (Slider)",
  [CT.detailedList]: "Detailed list",
  [CT.bubble]: "Tile view",
};

export const TEMPLATE_FILTER_OPTIONS = Object.entries(TEMPLATE_LABELS)
  .map(([value, label]) => ({ value, label }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const getEditUrl = (calendar) =>
  calendar.integration
    ? "/calendar/" + calendar.uuid
    : "/attach-integration/" + calendar.uuid;

// Only Name and Last edited sort (README §3: "Integration and Template are
// categories, so they filter... Only Name and Last edited sort") — feeds
// useSortableTable, kept separate from Table.jsx's own header/column list.
export const SORT_COLUMNS = [
  {
    id: "name",
    sort: (direction) => (a, b) =>
      direction === "asc"
        ? a.name.localeCompare(b.name)
        : b.name.localeCompare(a.name),
  },
  {
    id: "lastEdited",
    sort: (direction) => (a, b) =>
      direction === "asc" ? a.modified - b.modified : b.modified - a.modified,
  },
];
